import type { HttpError } from '@wix/fe-essentials/http-client';
import has from 'lodash/has';
import { Details } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export type { Details as ErrorDetails } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';

export function isHttpError(err: unknown): err is HttpError {
  return has(err, 'response');
}

export function isErrorDetails(details: unknown): details is Details {
  return has(details, 'applicationError') || has(details, 'validationError');
}

export function isDetailsResponse(res: unknown): res is { details: unknown } {
  return has(res, 'details');
}

export function isErrorDetailsHttpError(
  err: unknown,
): err is { response: { data: Details } } {
  return isHttpError(err) && isErrorDetails(err.response?.data);
}

// servers errors are 5xx
export function isServerErrorCode(err: unknown) {
  return (
    isHttpError(err) &&
    typeof err?.response?.status === 'number' &&
    err?.response?.status >= 500 &&
    err?.response?.status < 600
  );
}
